import BaseSportScoring from './BaseSportScoring';

class VolleyballScoring extends BaseSportScoring {
  constructor() {
    super('volleyball');
  }

  get label() { return 'Volleyball'; }

  /**
   * Position-based metric restrictions:
   * - Libero: cannot record kills, attack errors, blocks, smashes, setter dumps, tips, or placement shots
   * - Non-setters: cannot record setter dumps
   */
  canRecordMetric(metricKey, player) {
    const liberoRestricted = ['kill', 'attackError', 'blockSolo', 'blockAssist', 'setterDump', 'tip', 'placementShot'];
    if (player?.position === 'Libero' && liberoRestricted.includes(metricKey)) {
      return { allowed: false, reason: 'Liberos cannot record attack or block actions.' };
    }
    if (metricKey === 'setterDump' && player?.position && player.position !== 'Setter') {
      return { allowed: false, reason: 'Setter Dump is only available for Setters.' };
    }
    return { allowed: true };
  }

  getEventDescription(metric, player) {
    const playerName = player?.name || player?.full_name || player?.username || 'Player';
    const pos = player?.position ? ` (${player.position})` : '';
    return `${playerName}${pos} – ${metric.label}`;
  }
}

export default VolleyballScoring;
